module.exports = __webpack_public_path__ + "static/media/afd.506a731c.png";